import { trackPromise } from 'react-promise-tracker';

export async function registerCampaign(Nombre, Descripcion, Votos, userToken) {
   
    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/registrarcampana', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': userToken
        },
        body: JSON.stringify({"Nombre": Nombre, "Descripcion":  Descripcion, "Votos": Votos})
    }).then(data => data.json()))
}